import { render, staticRenderFns } from "./DepartmentConnections.vue?vue&type=template&id=c2b294c0&scoped=true"
import script from "./DepartmentConnections.vue?vue&type=script&lang=js"
export * from "./DepartmentConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b294c0",
  null
  
)

export default component.exports